import React from 'react';
import { sortAscAZ } from '../../leaderboard/js/components/sortingStrategies';
import CustomEventLeaderboardNameColumn from './custom-event-leaderboard-name-column';
import CustomEventLeaderboardPlayersColumn from './custom-event-leaderboard-players-column';
import CustomEventLeaderboardHeader from './custom-event-leaderboard-header';

class CustomEventLeaderboardAlphaList extends React.Component {
    renderRow(player, options) {
        return (
            <div className="custom-event-leaderboard__alphalist" key={player.scoringEnginePlayerId}>
                <CustomEventLeaderboardNameColumn options={options.customEventLeaderboardDatasource} player={player} />
                {
                    options.customEventLeaderboardDatasource.isTeamEvent &&
                    <div className="custom-event-leaderboard__player-list">
                        <CustomEventLeaderboardPlayersColumn playersList={player} />
                    </div>
                }
            </div>
        );
    }

    render() {
        const { players, options } = this.props;

        if (!Array.isArray(players)) return null;

        const sortedPlayers = sortAscAZ(players, 'name');

        return (
            <div className="custom-event-leaderboard">
                <CustomEventLeaderboardHeader logo={options.customEventLeaderboardDatasource.logo} patronLogo={options.customEventLeaderboardDatasource.patronLogo}></CustomEventLeaderboardHeader>
                {sortedPlayers.map((player) => this.renderRow(player, options))}
            </div>
        );
    }
}

export default CustomEventLeaderboardAlphaList;
